import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import Dashboard from "./Features/Dashboard/Dashboard";
import Devices from "./Features/Devices/Devices";
import Threats from "./Features/Threats/Threats";
import Loader from "../../components/Loader";

export default function SentinelOne() {
    const { apiUrl } = useContext(AuthContext);
    const [linkPath, setLinkPath] = useState('dashboard');
    const { t } = useTranslation();

    const handleNavigation = (path) => {
        setLinkPath(path);
    };

    const getDashboard = async () => {
        const res = await axios(`${apiUrl}sentinelone/dashboard`, {
            method: "get",
            withCredentials: true
        })
        return res.data;
    }

    const dashboard = useQuery({
        queryKey: ["dashboard"],
        queryFn: getDashboard,
    });

    if (!dashboard.isLoading && !dashboard.data) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Service actuellement indisponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                {!dashboard.isLoading ? (
                    <article className="sentinelone">
                        <div className="ecp-container-content-header mb-1">
                            <div className="ecp-container-content-header-title">
                                <div className="page-title page-logo">
                                    <img src="./assets/sentinelone.png" alt="Logo de SentinelOne" />
                                    <h1 className="page-title">SentinelOne</h1>
                                </div>
                            </div>
                        </div>
                        <div className="menu-statistics-webex">
                            <div onClick={() => handleNavigation('dashboard')} className={linkPath === 'dashboard' ? 'active' : ''}>{t("Dashboard")}</div>
                            <div onClick={() => handleNavigation('devices')} className={linkPath === 'devices' ? 'active' : ''}>{t("Devices")}</div>
                            <div onClick={() => handleNavigation('threats')} className={linkPath === 'threats' ? 'active' : ''}>{t("Threats")}</div>
                        </div>
                        {linkPath === 'dashboard' ? (
                            <div>
                                <Dashboard dashboard={dashboard} />
                            </div>
                        ) : linkPath === 'devices' ? (
                            <div>
                                <Devices />
                            </div>
                        ) : (
                            <div>
                                <Threats />
                            </div>
                        )}
                    </article>
                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
}